import { render, staticRenderFns } from "./LegalSeguimiento.vue?vue&type=template&id=0affbabb&scoped=true&"
import script from "./LegalSeguimiento.vue?vue&type=script&lang=js&"
export * from "./LegalSeguimiento.vue?vue&type=script&lang=js&"
import style0 from "./LegalSeguimiento.vue?vue&type=style&index=0&id=0affbabb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affbabb",
  null
  
)

export default component.exports